// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unsub{padding:40px}.unsub p{margin:10px 0}.unsub button{background-color:#fb2d7f;border:none;border-radius:4px;color:#fff;cursor:pointer;display:inline-block;font-size:16px;margin-top:24px;padding:8px 28px;-webkit-text-decoration:none;text-decoration:none;transition:all .2s ease}.unsub a{color:hsla(0,0%,100%,.35);display:block;font-size:1.4rem;margin-top:10px}.unsub a:hover{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
